/* eslint-disable  @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import {
  defineDataset,
  EDatasetColors,
  EDatasetColorTypes,
  filterTicksVarA,
  getTooltipLabelVarA,
  getTooltipTitleVarA,
  verticalGridLineColorCb,
  yAxisTicksCb,
  TChartFactoryProps,
} from '@cian/react-chartjs-component';
import { getPriceUnit } from '../../selectors/realtyValuation';
import { EChartType } from '../../types/charts';
import { ERoomType, IRealtyValuation } from '../../types/realtyValuation';

export const useDynamicPricesChartCfg = (
  { priceDynamics: { charts } }: IRealtyValuation,
  roomType: ERoomType,
): TChartFactoryProps => {
  const priceUnit = getPriceUnit(EChartType.Price);

  return React.useMemo(() => {
    const chart = charts.find(({ roomType: rt }) => rt === roomType);
    const { datesLabels, firstLineValues, maxChartValue, minChartValue, labelStep } = chart!.chart;

    const line = defineDataset({
      data: firstLineValues,
      color: EDatasetColors.BLUE,
      colorType: EDatasetColorTypes.GRADIENT,
    });

    return {
      datasetCfgCreators: [line],
      chartCfgParams: {
        chartType: 'line',
        labelsData: datesLabels as string[],
        yMaxVal: maxChartValue,
        yMinVal: minChartValue,
        yValStep: labelStep,
        tooltipTitleCb: getTooltipTitleVarA,
        tooltipLabelCb: getTooltipLabelVarA(priceUnit),
        xAfterTickToLabelConversion: filterTicksVarA,
        xGridLinesColor: verticalGridLineColorCb,
        yTicksCb: yAxisTicksCb(priceUnit),
      },
      chartHeight: 220,
    };
  }, [priceUnit, roomType, charts]);
};
